import React from 'react';
import Image from '../../common/Image';
import { imageWithIconDefaultProps, imageWithIconPropTypes } from '../propTypes';

const ImageWithIcon = ({
  src,
  alt,
  className,
  height,
  width,
  lazy,
  children,
  ...rest
}) => {
  return (
    <div className="sui-relative sui-text-inverse">
      <Image
        src={src}
        alt={alt}
        className={className}
        height={height}
        width={width}
        lazy={lazy}
        {...rest}
      />
      <div className="sui-flex sui-justify-center sui-items-center sui-bg-inverse
        sui-absolute sui-inset-0 sui-m-auto sui-pointer-events-none sui-rounded-full
        sui-h-20 sui-w-20 sui-shadow-md"
      >
        {children}
      </div>
    </div>
  );
};

ImageWithIcon.propTypes = imageWithIconPropTypes;
ImageWithIcon.defaultProps = imageWithIconDefaultProps;

export default ImageWithIcon;